export const ROUTES = {
  splash: 'splash',
  readyToCast: 'readyToCast',
  error: 'error',
  playerVod: 'playerVod',
  playerLive: 'playerLive',
  pin: 'readyToPin',
  goToLive: 'goToLive'
};
